import { ArrowUpRight } from "lucide-react";
import { LINKEDIN_GROUP_URL } from "@/lib/api";
import { openCalendly } from "@/lib/calendly";

const FOOTER_GROUPS = [
  { label: "Explore", links: [
    { label: "Mission", href: "/#mission", id: "mission" },
    { label: "Why Now", href: "/#why-now", id: "why-now" },
    { label: "The DCYB Wire", href: "/wire", id: "wire" },
    { label: "Academy", href: "/academy", id: "academy" },
  ] },
  { label: "Connect", links: [
    { label: "Get Involved", href: "/get-involved", id: "get-involved" },
    { label: "Partner With Us", href: "/#certified-partner", id: "partners" },
    { label: "Careers", href: "/careers", id: "careers" },
  ] },
];

const linkClass = "inline-flex min-h-8 items-center gap-1.5 text-[13px] text-[#3C4450] hover:text-[#0F141B] transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#0F141B]";

export default function FooterSection() {
  return (
    <footer data-testid="site-footer" className="border-t hairline bg-white relative">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-2 lg:grid-cols-[1fr_1.1fr_1fr] gap-x-5 gap-y-6 lg:gap-10 py-6 lg:py-8">
          <div className="order-1 min-w-0">
            <a href="/" aria-label="DCYB home" data-testid="footer-logo-link" className="inline-flex max-w-full transition-opacity hover:opacity-75">
              <img src="/dcyb-wordmark.png" alt="DCYB" data-testid="footer-logo" width="1169" height="245" className="w-40 max-w-full h-auto object-contain" draggable="false" />
            </a>
            <address data-testid="footer-address" className="mt-4 not-italic text-xs leading-5 text-[#5F6168]">
              Data Center Youngbloods, LLC<br />
              108 Atlantic Ave, Cohasset MA
            </address>
          </div>
          <nav aria-label="Footer navigation" data-testid="footer-nav" className="order-3 md:order-2 col-span-2 md:col-span-1 grid grid-cols-2 gap-5">
            {FOOTER_GROUPS.map((group) => (
              <div key={group.label}>
                <h2 className="font-mono-label text-[10px] tracking-normal uppercase text-[#71747B] mb-2">{group.label}</h2>
                <ul>
                  {group.links.map((link) => (
                    <li key={link.id}><a href={link.href} data-testid={`footer-${link.id}-link`} className={linkClass}>{link.label}<ArrowUpRight size={12} aria-hidden="true" className="opacity-60 shrink-0" /></a></li>
                  ))}
                </ul>
              </div>
            ))}
          </nav>
          <div className="order-2 md:order-3 md:col-span-2 lg:col-span-1 min-w-0">
            <a href="mailto:Luke@DCYB.ai" data-testid="footer-email-link" className={`${linkClass} font-semibold text-[#0F141B]`}>Luke@DCYB.ai<ArrowUpRight size={13} aria-hidden="true" /></a>
            <div className="flex flex-wrap gap-x-5">
              <a href={LINKEDIN_GROUP_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-linkedin-link" className={linkClass}>LinkedIn group<ArrowUpRight size={12} aria-hidden="true" /></a>
            </div>
            <div className="flex flex-wrap items-center gap-x-4 gap-y-2 mt-3">
              <a href="/#book" onClick={openCalendly} data-testid="footer-book-meeting-link" className="chrome-btn-dark inline-flex max-w-full items-center gap-1.5 px-2 lg:px-3 py-2.5 font-mono-label text-[10px] !tracking-normal">Book a Meeting<ArrowUpRight size={12} aria-hidden="true" className="shrink-0" /></a>
              <a href="/#book" data-testid="footer-press-link" className={`${linkClass} text-xs`}>Press / Inquiries</a>
            </div>
          </div>
        </div>
        <div className="border-t hairline min-h-44 sm:min-h-0 pt-14 pb-5 sm:py-5 pr-24 sm:pr-36 2xl:pr-0 flex flex-wrap content-start items-center justify-between gap-x-6 gap-y-2 text-[10px] leading-5 text-[#71747B]">
          <p data-testid="footer-copyright">© {new Date().getFullYear()} Data Center Youngbloods, LLC · All rights reserved</p>
          <span data-testid="footer-built-for-you" className="font-mono-label tracking-normal">BUILT FOR YOU · v1.0</span>
        </div>
      </div>
    </footer>
  );
}